import { z } from 'zod';
import { CONVERSATION_ACTION_TYPES } from '@paction-2.0/util/constants/conversationActions';

import {
  deleteProviderJson,
  getProviderJson,
  postProviderJson,
  putProviderJson
} from '../providerClient';

export const nextStepTemplateSchema = z.object({
  id: z.number(),
  title: z.string(),
  body: z.string(),
  actionType: z.enum(CONVERSATION_ACTION_TYPES).nullable(),
  sortOrder: z.number(),
  useCount: z.number(),
  lastUsedAt: z.string().nullable()
});

export type NextStepTemplate = z.infer<typeof nextStepTemplateSchema>;

export const nextStepTemplateListSchema = z.object({
  items: z.array(nextStepTemplateSchema)
});

export type NextStepTemplateInput = {
  title: string;
  body: string;
  actionType: NextStepTemplate['actionType'];
};

export const getNextStepTemplates = () =>
  getProviderJson('/providers/messaging/next-steps', {
    schema: nextStepTemplateListSchema
  });

export const createNextStepTemplate = (input: NextStepTemplateInput) =>
  postProviderJson('/providers/messaging/next-steps', input, {
    schema: nextStepTemplateSchema
  });

export const updateNextStepTemplate = (
  id: number,
  input: Partial<NextStepTemplateInput>
) =>
  putProviderJson(`/providers/messaging/next-steps/${id}`, input, {
    schema: nextStepTemplateSchema
  });

export const deleteNextStepTemplate = (id: number) =>
  deleteProviderJson(`/providers/messaging/next-steps/${id}`);

export const draftNextStepTemplate = (input: {
  brief: string;
  title?: string;
  actionType: NextStepTemplate['actionType'];
}) =>
  postProviderJson('/providers/messaging/next-steps/draft', input, {
    schema: z.object({ title: z.string(), body: z.string() })
  });
